import React from 'react';
import { useParams } from 'react-router-dom';
import { Button, Empty, Spin } from 'antd';
import InfoCard from '../../../../../../components/common/InfoCard/InfoCard';
import {
  RoomComments,
  useRoomCommentsQuery,
} from '../../../../../../../../components/RoomComments';
import styles from './FlatComments.module.scss';

const FlatComments = () => {
  const params = useParams();

  const addressId = Number(params.pageTabId);

  return (
    <InfoCard title="Комментарии">
      <RoomComments hasModal addressId={addressId}>
        <Content />
      </RoomComments>
    </InfoCard>
  );
};

export default FlatComments;

function Content() {
  const { data, isFetching } = useRoomCommentsQuery();

  const comments = Array.isArray(data) ? data : undefined;

  return (
    <Spin spinning={isFetching}>
      <LastComments comments={comments} />
    </Spin>
  );
}

const COMMENTS_SIZE = 4;
const emptyArr = [];
const OpenModalBtn = RoomComments.createOpenModal(Button);

function LastComments({ comments = emptyArr }) {
  const lastComments = comments.slice(0, COMMENTS_SIZE);

  return (
    <>
      {lastComments.length > 0 ? (
        <div className={styles.lastCommentsWrapper}>
          {lastComments.map((comment) => (
            <RoomComments.CommentCard key={comment.id} comment={comment} />
          ))}
        </div>
      ) : (
        <Empty
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          description="Комментариев нет"
        />
      )}

      <OpenModalBtn className={styles.openModalBtn}>
        {comments.length > COMMENTS_SIZE
          ? `Показать все комментарии (${comments.length})`
          : 'Добавить комментарий'}
      </OpenModalBtn>
    </>
  );
}
